import React from 'react'

const DateInput = ({
  label,
  width,
  height,
  value,
  onChange,
  placeholder,
  required,
  row,
  isflex,
  disabled,
  ...props
}) => {
  return (
    <div
      className="textfield-wrapper"
      style={{
        width,
        height,
        display: row || isflex ? 'flex' : '',
        gap: row ? '56px' : '',
        flexDirection: row ? 'row' : '',
        margin: row ? '0px' : '',
        flex: row || isflex ? '1 0 0' : '',
      }}
    >
      {label && (
        <label
          style={{
            width: row ? '156px' : '',
          }}
          className="textfield-label"
        >
          {label} {required && <span className="req">*</span>}
        </label>
      )}

      <input
        type="date"
        className="textfield-input"
        value={value}
        onChange={onChange}
        height={height}
        placeholder={placeholder}
        {...props}
        style={{
          margin: row ? '0px' : '',
              flex: row ? '1 0 0' : '',
        }}
        disabled={disabled}
      />
    </div>
  )
}

export default DateInput
